import { Box, Theme, TypographyProps } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

type RichTextProps = TypographyProps & { content: string };

const useStyles = makeStyles<Theme>((theme) => ({
    root: {
        '& i': {
            fontStyle: 'italic',
        },
        '& p:first-of-type': {
            paddingTop: 0,
            paddingBottom: 0,
        },
        '& a:link': {
            textDecoration: 'underline',
            color: theme.palette.primary1,
        },
        '& a:visited': {
            color: theme.palette.primary1,
        },
        '& a:hover': {
            color: theme.palette.primary1,
        },
        '& a:active': {
            color: theme.palette.primary1,
        },
        '& ul': {
            listStyle: 'disc',
        },
        '& li::before': {
            content: '•',
            paddingRight: theme.spacing(1),
            color: theme.palette.primary1,
        },
        '& h1': {
            ...theme.typography.h1,
        },
        '& h2': {
            ...theme.typography.h2,
        },
        '& h3': {
            ...theme.typography.h3,
        },
        '& h4': {
            ...theme.typography.h4,
            '& b': {
                fontFamily: 'InterExtraBold',
            },
        },
        '& h5': {
            ...theme.typography.h5,
            '& b': {
                fontFamily: 'InterExtraBold',
            },
        },
        '& h6': {
            ...theme.typography.h6,
            '& b': {
                fontFamily: 'InterExtraBold',
            },
        },
        '& .caption': {
            ...theme.typography.caption,
            '& b': {
                ...theme.typography.captionBold,
            },
        },
        '& .overline': {
            ...theme.typography.overline,
        },
    },
}));

const RichText: React.FC<RichTextProps> = (props: RichTextProps) => {
    const { content, ...otherProps } = props;
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Box {...otherProps}>
                <span
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: content,
                    }}
                />
            </Box>
        </div>
    );
};

export default RichText;
